import { gql } from 'apollo-angular';
import { UserStorageFragment } from '@shared/graphql/fragments/user-storage.fragment';

export const MeSettingsDocument = gql`
  query meSettings {
    me {
      ...UserStorage
      experienceYears
      country
      website
      description
      discordName
    }
  }
  ${UserStorageFragment}
`;
